import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "EnergyListPage" */
	'pages/vehicle/Energy/EnergyListPage'));

export default [{ component, exact: true, path: '/energies' }];